import React from "react";
import _ from "lodash";
import { formatMoneyWithCurrency } from "components/playground/home-dashboard-v1/ReportsHelper";
import PopupWrapper from "components/common/PopupWrapper";
import UprTargetingsView from "components/ops-mgmt/account/custom-upr/UprTargetingsView";
import AdvertiserAndBrandsSelector from "components/ops-mgmt/account/custom-upr/AdvertiserAndBrandsSelector";
import SensitiveCategoriesSelector from "components/ops-mgmt/account/custom-upr/SensitiveCategoriesSelector";
import {
  GAM_CREATIVE_TYPES_NAME,
  SKIPPABILITY_TYPE,
} from "components/ops-mgmt/account/custom-upr/Constants";
import PriceSectionView from "components/common/PriceSectionView";

const PRICE_TYPE_NAME = {
  0: "Floor",
  1: "Target CPM",
  // LGO: 2, // not an option for brand price settings
};

class UprCustomInfoPopover extends React.Component {
  render() {
    const {
      networkId,
      networkInfo,
      custom,
      triggerElement,
      units,
      virtualPlacements,
      placements = [],
      place = "bottom",
      onOpen,
      onClose,
    } = this.props;

    return (
      <PopupWrapper
        place={place}
        triggerType="click"
        hideArrow={false}
        triggerElement={triggerElement}
        onOpen={onOpen}
        onClose={onClose}
        popupElement={
          <div
            className="shadow border p-4"
            style={{ width: "600px", maxHeight: "600px", overflow: "auto" }}
          >
            {custom ? (
              <UprTargetingsView
                id={custom.id}
                name={custom.name}
                networkId={networkId}
                targetingSection={custom.targetingSection}
                units={units}
                virtualPlacements={virtualPlacements}
                placements={placements}
              >
                <div>
                  <Title>Price Section</Title>
                  <div className="bg-gray-200 px-2 pb-2 pt-1">
                    <Title>Price:</Title>
                    <PriceSectionView
                      priceType={custom.priceSection.priceType}
                      item={{
                        priceType: custom.priceSection.priceType,
                        price: custom.priceSection.price,
                      }}
                      currency={networkInfo.currency}
                      customClass="flex items-center gap-1"
                    ></PriceSectionView>
                    <div className="mt-2">
                      <Title>
                        Branded Price Settings (
                        {custom.priceSection.brandedPriceSettings
                          ? custom.priceSection.brandedPriceSettings.length
                          : 0}
                        ):
                      </Title>
                      <div>
                        {(custom.priceSection.brandedPriceSettings || [])
                          .length > 0 ? (
                          <div className="flex flex-col gap-1 divide-y-2 bg-gray-100 px-2">
                            {custom.priceSection.brandedPriceSettings.map(
                              (item, index) => {
                                let numOfAdvertisersAndBrands = 0;
                                if (item.targeting.advertisersAndBrands) {
                                  numOfAdvertisersAndBrands = _.filter(
                                    item.targeting.advertisersAndBrands,
                                    (a) => {
                                      return a.advertiserId !== "0";
                                    }
                                  ).length;
                                }
                                return (
                                  <div key={index}>
                                    <div
                                      key={index}
                                      className="flex flex-col gap-1"
                                    >
                                      {item.branded && (
                                        <div className="pb-1">
                                          <div className="text-sm font-semibold leading-tight text-gray-800">
                                            Branded
                                          </div>
                                          <div
                                            className={
                                              item.branded === "BLOCKED" &&
                                              "text-red-600"
                                            }
                                          >
                                            {item.branded}
                                          </div>
                                        </div>
                                      )}

                                      <div className="pb-1">
                                        <div className="mt-1 text-sm font-semibold leading-tight text-gray-800">
                                          Advertisers and Brands{" "}
                                          <span>
                                            ({numOfAdvertisersAndBrands})
                                          </span>
                                        </div>
                                        <div className="leading-tight">
                                          {item.targeting
                                            .advertisersAndBrands ? (
                                            <div>
                                              <AdvertiserAndBrandsSelector
                                                networkId={networkId}
                                                targeting={
                                                  item.targeting[
                                                    "advertisersAndBrands"
                                                  ]
                                                }
                                                isDisabled={true}
                                              ></AdvertiserAndBrandsSelector>
                                            </div>
                                          ) : (
                                            "-"
                                          )}
                                        </div>
                                      </div>

                                      <div className="pb-1">
                                        <div className="mt-1 text-sm font-semibold leading-tight text-gray-800">
                                          Sizes
                                        </div>
                                        <div>
                                          {item.targeting.sizes ? (
                                            <SegmentTarget
                                              targetType="SIZES"
                                              targetData={item.targeting.sizes}
                                            ></SegmentTarget>
                                          ) : (
                                            "-"
                                          )}
                                        </div>
                                      </div>

                                      <div className="pb-1">
                                        <div className="mt-1 text-sm font-semibold leading-tight text-gray-800">
                                          Sensitive Categories{" "}
                                          {(
                                            item.targeting
                                              .sensitiveCategories || []
                                          ).length > 0
                                            ? `(${item.targeting.sensitiveCategories.length})`
                                            : ""}
                                        </div>
                                        <div>
                                          {item.targeting
                                            .sensitiveCategories ? (
                                            <SensitiveCategoriesSelector
                                              isReadonly={true}
                                              networkId={networkId}
                                              targeting={
                                                item.targeting
                                                  .sensitiveCategories
                                              }
                                            ></SensitiveCategoriesSelector>
                                          ) : (
                                            "-"
                                          )}
                                        </div>
                                      </div>

                                      <div className="pb-1">
                                        <div className="mt-1 text-sm font-semibold leading-tight text-gray-800">
                                          Creative Format
                                        </div>
                                        <div className="text-sm">
                                          {item.targeting.creativeTypes ? (
                                            <span>
                                              {
                                                GAM_CREATIVE_TYPES_NAME[
                                                  item.targeting.creativeTypes
                                                ]
                                              }
                                            </span>
                                          ) : (
                                            "Any Creative Type"
                                          )}
                                        </div>
                                      </div>

                                      <div className="pb-1">
                                        <div className="mt-1 text-sm font-semibold leading-tight text-gray-800">
                                          Video Option
                                        </div>
                                        <div className="text-xs">
                                          {item.targeting.videoOption ? (
                                            <>
                                              <label className="block text-gray-800">
                                                Minimum Duration (seconds)
                                              </label>
                                              <span className="mb-1">
                                                {
                                                  item.targeting.videoOption
                                                    .minDuration
                                                }{" "}
                                              </span>

                                              <label className="block text-gray-800">
                                                Video Skippability Type
                                              </label>
                                              <span className="">
                                                {
                                                  SKIPPABILITY_TYPE[
                                                    item.targeting.videoOption
                                                      .type
                                                  ]
                                                }
                                              </span>
                                            </>
                                          ) : (
                                            "-"
                                          )}
                                        </div>
                                      </div>

                                      <div className="">
                                        <div className="mt-1 text-sm font-semibold leading-tight text-gray-800">
                                          Price
                                        </div>
                                        <div className="text-sm">
                                          {PRICE_TYPE_NAME[item.priceType]}{" "}
                                          {formatMoneyWithCurrency({
                                            currency:
                                              item.currency ||
                                              networkInfo.currency,
                                            value: item.price,
                                          })}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              }
                            )}
                          </div>
                        ) : (
                          "-"
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </UprTargetingsView>
            ) : (
              <div className="text-gray-800">No data found.</div>
            )}
          </div>
        }
      ></PopupWrapper>
    );
  }
}

class Title extends React.Component {
  render() {
    const { children } = this.props;
    return <div className="font-semibold text-gray-900">{children}</div>;
  }
}

class SegmentTarget extends React.PureComponent {
  render() {
    const { targetData } = this.props;

    const isInclude = targetData.includes;
    let op = isInclude ? "Includes" : "Excludes";
    let targets = isInclude ? targetData.includes : targetData.excludes;

    targets = _.map(targets, (t) => {
      return t;
    });

    return (
      <div className="text-sm">
        {targetData && (
          <div>
            <div
              className={`${
                isInclude ? "text-green-500" : "text-red-500"
              } font-medium`}
            >
              {op} ({targets.length})
            </div>
            <div className="flex flex-wrap gap-1">
              {targets.map((value, i) => {
                return (
                  <div key={i} className="bg-gray-200 px-1">
                    {value}
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default UprCustomInfoPopover;
